import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { useTranslation } from 'react-i18next';
import { BenefitPaper } from '../../component/benefitTabs/BenefitPaper';
import { getBenefitIcon } from '../../module/benefits/BenefitIcon';
import BenefitSubPage from '../../module/benefits/BenefitSubPage';
import { useAdditionalBikeleasingColumns } from '../../module/benefits/bikeleasing/context/useAdditionalBikeleasingColumns';
import { useBikeleasingPrecondition } from '../../module/benefits/bikeleasing/useBikeleasingPrecondition';
import { AuthorizedLayout } from '../../module/navigation/AuthorizedLayout';
import { BenefitEmployeesPage } from '../benefit/BenefitEmployeesPage';

export function BikeleasingEmployeesPage() {
  const { t } = useTranslation('benefitsModule');
  const { isPreconditionMet, PreconditionComponent } = useBikeleasingPrecondition();
  const benefit = BenefitDTOBenefitEnum.Bikeleasing;
  const additionalColumns = useAdditionalBikeleasingColumns();

  return isPreconditionMet ? (
    <BenefitEmployeesPage benefit={benefit} additionalColumns={additionalColumns} />
  ) : (
    <AuthorizedLayout
      title={t('subPage.employees')}
      breadcrumbs={[{ title: t(`${benefit}.title`), to: `/benefits/${benefit.toLowerCase()}` }]}
    >
      <BenefitSubPage
        icon={getBenefitIcon(BenefitDTOBenefitEnum.Bikeleasing)}
        title={t(`${benefit}.title`)}
        subTitle={t('subPage.employees')}
      >
        <BenefitPaper>{PreconditionComponent}</BenefitPaper>
      </BenefitSubPage>
    </AuthorizedLayout>
  );
}
